import { Component, EventEmitter, Output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';

@Component({
  selector: 'dl-notification-search',
  standalone: true,
  imports: [OneWebComponentsAngularModule],
  templateUrl: './notification-search.component.html',
  styleUrl: './notification-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationSearchComponent {
  @Output() searchValue = new EventEmitter();

  public applyFilter(searchValue: string): void {
    this.searchValue.emit(searchValue);
   
  }
}
